import moneda_model from '@/shared/models/moneda_model';
import unidad_medida_model from '@/shared/models/unidad_medida_model';
import costo_tipo_model from './costo_tipo.model';

export default {
  Codigo: null,
  CodigoCostoTipo: null,
  Descripcion: '',
  CodigoUnidadMedida: null,
  Costo: null,
  CodigoMoneda: null,
  Activo: true,
  Orden: null,
  CostoTipo: { ...costo_tipo_model },
  UnidadMedida: { ...unidad_medida_model },
  Moneda: { ...moneda_model },
  RelCostoElementoTipo: [],
  CodigoCategoriaCosto: null,
};
